import {Component, inject, model, ModelSignal, OnInit} from '@angular/core';
import {
  CSV_EXPORT_ACTION,
  INITIAL_STATE_TOKEN,
  ITableAction,
  TableControlComponent,
  TableControlModule,
  ToolbarStore
} from "frontier";
import ControlGuids from "../../../../api/ControlGuids";
import {of, switchMap} from "rxjs";
import {debounceTime} from "rxjs/operators";

@Component({
  selector: 'app-booking-record-export',
  templateUrl: '../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
  standalone: true,
  imports: [TableControlModule],
  providers: [
    {provide: TableControlComponent, useExisting: BookingRecordExportComponent},
    {provide: INITIAL_STATE_TOKEN, useValue: {filter: null}},
  ],
  })
export class BookingRecordExportComponent extends TableControlComponent implements OnInit {
  private _toolbarStore: ToolbarStore = inject(ToolbarStore);
  override tableName: string = 'Buchhaltung Export';
  override GUID: string = ControlGuids.TBookingrecordExport;
  override actions: ModelSignal<ITableAction[]> = model<ITableAction[]>([CSV_EXPORT_ACTION]);

  override ngOnInit(): void {
    super.ngOnInit();
    this.subs.add(
      this._toolbarStore.toolbarFilterDto$.pipe(
        debounceTime(500),
        switchMap((globalFilter) => {
          // Update the apiInstance and trigger the fetching of the data with the new filter.
          this.patchFilter({
            ...globalFilter
          })
          return of(globalFilter)
        }),
      ).subscribe()
    );
  }
}
